import { useEffect, useMemo, useRef, useState } from 'react'

import { companyAddress, culture, genAxisTick, university, companyTimeline, menus } from './configs'
import { AnimateBox } from '../../components/animate-box'
import { Wrap } from '../../components/wap'
import { STATIC_OBS_URL } from '../../consts'
import { ScrollA } from '../home/scroll-a'
import { ScrollB } from '../home/scroll-b'

const companyTimelineHeight = 224
export const AboutDetail = () => {
  const axisTicks = useMemo(() => genAxisTick(companyTimeline.length), [])
  const [height, setHeight] = useState(companyTimelineHeight)
  const [unitHeight, setUnitHeight] = useState(0)
  const ref = useRef<HTMLDivElement>(null)

  const scroll = () => {
    const nav = document.querySelector('nav ul')
    const width = document.documentElement.clientWidth || document.body.clientWidth

    const sections = document.querySelectorAll('.section')
    const navItems = nav?.querySelectorAll('li')
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

    if (nav) {
      if (scrollTop > 600 && width >= 768) {
        nav.classList.add('fixed-box')
      } else {
        nav.classList.remove('fixed-box')
      }

      if (scrollTop < 600) {
        document.querySelector('nav li.active')?.classList.remove('active')
        document.querySelector('nav li:first-child')?.classList?.add('active')
      }
    }

    if (width <= 768 || scrollTop < 600) return

    let currentSectionId = ''
    sections.forEach(section => {
      const rect = section.getBoundingClientRect()
      if (rect.top <= 100 && rect.bottom >= 100) {
        currentSectionId = `#${section.id}`
      }
    })

    navItems?.forEach(item => {
      item.classList.toggle(
        'active',
        item.querySelector('a')?.getAttribute('href') === currentSectionId
      )
    })
  }

  useEffect(() => {
    window?.addEventListener('scroll', scroll)
    const width = document.documentElement.clientWidth || document.body.clientWidth

    const el = ref.current
    if (!el || width < 768) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          el.classList.add('fullscreen')
        } else {
          el.classList.remove('fullscreen')
        }
      },
      {
        threshold: 0.6 // 当 60% 视频区域出现在视口中时触发
      }
    )

    observer.observe(el)

    return () => {
      window?.removeEventListener('scroll', scroll)
      // observer.disconnect()
    }
  }, [])

  useEffect(() => {
    const handleResize = () => {
      const isMini = window.innerWidth <= 768
      setHeight(!isMini ? companyTimelineHeight : 112)
      setUnitHeight(!isMini ? 86 : 54)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <Wrap className='about'>
      <div
        className='public-banner-box'
        style={{
          backgroundImage: `url(${STATIC_OBS_URL}/website/home/about/16542cc6a2b716ebe8e63a5943154c9904365fcf.jpg)`
        }}
      >
        <AnimateBox tagName='h2'>企业介绍</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          系统仿真工业软件和数字孪生解决方案提供商
        </AnimateBox>
      </div>

      <nav className='nav bg-color-white pd'>
        <ul>
          {menus.map(({ name, props }, index) => (
            <AnimateBox
              animateDelay={0.5 + index * 0.1}
              className={!index ? 'active' : ''}
              key={name}
              tagName='li'
            >
              <a {...props}>{name}</a>
            </AnimateBox>
          ))}
        </ul>
      </nav>

      <div className='bg-color-white mb8'>
        <div className='container' style={{ padding: 0 }}>
          <div className='company-profile box section pd' id='company-profile'>
            <AnimateBox animateDelay={1} className='title mb20' tagName='h1'>
              公司简介
            </AnimateBox>

            <AnimateBox animateDelay={0.1} tagName='p'>
              北京世冠金洋科技发展有限公司（简称&ldquo;世冠科技&rdquo;）成立于2003年，是国产系统仿真软件领域的领军者、MATLAB/Simulink的国产替代者、工业装备数字孪生解决方案供应商。聚焦智能制造的系统正向设计领域，致力于解决复杂装备数字孪生的工业应用需求。
            </AnimateBox>
            <AnimateBox animateDelay={0.3} tagName='p'>
              作为国产系统仿真软件领域的领军者，世冠科技具备<strong>国家级高新技术企业</strong>、
              <strong>专精特新&ldquo;小巨人&rdquo;企业</strong>、
              <strong>北京市两业融合试点企业</strong>、<strong>北京市知识产权试点单位</strong>、
              <strong>ISO 26262认证</strong>、<strong>ISO9001质量管理体系认证</strong>
              等资质，先后获得2019中国先进技术转化应用大赛金奖、工信部2019、2020中国工业互联网APP优秀解决方案及最佳行业创新应用奖、2020年中国航空学会科学技术奖、
              <strong>2020年系统仿真领域最具影响力企业</strong>
              、2021数字仿真科技奖卓越应用奖、2021工业软件创新应用大赛工业软件创新奖、
              <strong>2021年北京市科学技术进步奖二等奖</strong>
              、2023年北京数字化服务商、北京数字化创新解决方案、2024年国际技术交易大会
              <strong>百项新技术新产品榜单</strong>
              、2025天元杯智能工业软件创新应用大赛智创先锋奖等多项荣誉。
            </AnimateBox>
            <AnimateBox animateDelay={0.5} tagName='p'>
              世冠科技坚持技术驱动，基于模型的系统工程（MBSE），完全自主研发了
              <strong>GCAir系统仿真测试验证一体化平台</strong>和
              <strong>GCKontrol系统设计与仿真软件</strong>
              （对标美国MATLAB/Simulink软件），构建起支撑产品控制系统研发设计的
              <strong>建模、仿真、测试一体化工具链</strong>，已通过ISO26262功能安全认证，并在
              <strong>航空、汽车、航天、航发、船舶</strong>等行业开展规模化应用。
            </AnimateBox>

            <AnimateBox className='intro' />
          </div>
        </div>
        {/* todo: 换素材，后期素材准备好了，需要替换！！！ */}
        {/* <div className='video-warp pd' ref={ref}>
          <video
            autoPlay
            controls
            muted
            playsInline
            className='video'
            poster={`${STATIC_OBS_URL}/website/home/about/e8a5a909e24ed15079648144516f38f469c7b2ae.png`}
          >
            <source
              src={`${STATIC_OBS_URL}/website/home/about/1775732122436.mp4`}
              type='video/mp4'
            />
          </video>
        </div> */}
      </div>

      <div className='container-history section' id='container-history'>
        <div className='box pd'>
          <AnimateBox className='title' tagName='h1'>
            发展历程
          </AnimateBox>

          <div className='history'>
            <ul className='list'>
              {companyTimeline.map(({ year, content }, index) => (
                <AnimateBox animateDelay={0.3 + index * 0.2} key={year} tagName='li'>
                  <div
                    className='item'
                    style={{
                      height: `${height + index * unitHeight}px`
                    }}
                  >
                    <h1>{year}</h1>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                  </div>
                  <div className='year'>{year}</div>
                </AnimateBox>
              ))}
            </ul>

            <AnimateBox className='line'>
              {axisTicks.map((ticks, index) => {
                const key = index
                return (
                  <div className='item' key={key}>
                    {ticks.map(tick => (
                      <div className='tick' key={tick} />
                    ))}
                  </div>
                )
              })}
            </AnimateBox>
          </div>
        </div>
      </div>

      <div className='bg-color-white'>
        <div className='container section' id='culture'>
          <div className='box pd'>
            <AnimateBox className='title'>企业文化</AnimateBox>

            <div className='culture'>
              {culture.map(({ title, url, subtitle, content }, index) => (
                <AnimateBox
                  animateDelay={0.2 + 0.3 * index}
                  className='item hover-scale'
                  key={title}
                  style={{ backgroundImage: `url(${url})` }}
                >
                  <div className='mask'>
                    <h1>{title}</h1>
                    <p>{subtitle}</p>
                    <div
                      className={`content ${index === culture.length - 1 ? 'value' : ''}`}
                      dangerouslySetInnerHTML={{ __html: content }}
                    />
                  </div>
                </AnimateBox>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className='container-history section' id='cooperator'>
        <div className='box pd'>
          <AnimateBox className='title mb20' tagName='h1'>
            合作伙伴
          </AnimateBox>

          <div className='cooperator'>
            <AnimateBox tagName='p'>
              已服务于4大院士团队、100+行业头部客户、1000+工业企业用户
            </AnimateBox>

            <AnimateBox className='content'>
              <ScrollB />
            </AnimateBox>
          </div>
        </div>
      </div>

      <div className='bg-color-white' id='university'>
        <div className='container'>
          <div className='box pd'>
            <AnimateBox className='title mb20' tagName='h1'>
              合作高校
            </AnimateBox>

            <div className='university'>
              <AnimateBox animateDelay={0.3} tagName='p'>
                在高等院校学术交流与技术合作中，与北京航空航天大学、西北工业大学、北京理工大学、哈尔滨工程大学、武汉理工大学、北京交通大学、吉林大学、中国民航大学、中国石油大学（北京）、南京航空航天大学等10余所高校建立了GCKontrol联合实验室，加强系统设计与仿真关键技术攻关和人才培养。已有近100所高校使用世冠科技软件替代国外软件MATLAB进行授课，共同培养卓越拔尖人才，推动高校科研成果更好地向工程应用转化。
              </AnimateBox>

              <AnimateBox animateDelay={0.5} className='list'>
                {university.map(({ title, url }) => (
                  <div className='item hover-scale' key={url}>
                    <div
                      className='logo'
                      style={{ backgroundImage: `url(${STATIC_OBS_URL}/website/${url})` }}
                    />
                    <p>{title}</p>
                  </div>
                ))}
              </AnimateBox>
            </div>
          </div>
        </div>
      </div>

      <div className='container-history section' id='certificate'>
        <div className='box pd'>
          <AnimateBox className='title mb20' tagName='h1'>
            荣誉资质
          </AnimateBox>

          <div className='certificate'>
            <AnimateBox animateDelay={0.3} tagName='p'>
              世冠科技拥有一支由资深的工程师和技术专家组成的技术科研团队，累计获得上百项发明专利、软著，在关键技术上具备完全自主知识产权。先后参与了数字卫星、大型空间机械臂、国产大飞机、国产商用发动机等规模大、难度高的研发项目，为我国高精尖装备的技术提升起到了重要的推动作用。
            </AnimateBox>

            <AnimateBox animateDelay={0.5} className='mt'>
              <ScrollA />
            </AnimateBox>
          </div>
        </div>
      </div>

      <div className='bg-color-white'>
        <div className='container section' id='contact'>
          <div className='box pd'>
            <AnimateBox className='title' tagName='h1'>
              联系我们
            </AnimateBox>

            <div className='contact'>
              <div className='company-hq hover-scale'>
                <a
                  href='https://www.amap.com/place/B0JGAADJMI'
                  rel='noopener noreferrer'
                  target='_blank'
                >
                  <div
                    className='map'
                    style={{
                      backgroundImage: `url(${STATIC_OBS_URL}/website/home/about/about-map.png)`
                    }}
                  />
                </a>

                <AnimateBox className='info'>
                  <h1>世冠科技 运营总部</h1>
                  <ul>
                    <li>地址：北京市海淀区东北旺西路8号院尚东数字谷A3 二层</li>
                    <li>电话：4009960325</li>
                    <li>邮箱：marketing@globalcrown.com.cn</li>
                  </ul>
                </AnimateBox>
              </div>

              <div className='company'>
                {companyAddress.map(({ title, address, tel, email }, i) => (
                  <AnimateBox animateDelay={0.2 * i} className='item hover-scale' key={title}>
                    <h1>{title}</h1>
                    <ul>
                      {address && <li>地址：{address}</li>}
                      <li>电话：{tel}</li>
                      <li>邮箱：{email}</li>
                    </ul>
                  </AnimateBox>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrap>
  )
}
